ixModuleRouting(
    "impactx.purchaserequest",
    {
        "/purchaserequestdetail/:id/:prsId?": {
            template: "<ixa-purchase-request-detail></ixa-purchase-request-detail>",
            templateUrl: "shared/purchaserequest/statusdetaildialog.tmpl.html",
            controller: "PurchaseRequestDetailCtrl",
            controllerAs: "statusCtrl",
            process: "PurchaseRequestView",
            workspace: "shop",
        },
        "/purchaserequestlist": {
            template: "<ixa-purchase-request-list></ixa-purchase-request-list>",
            templateUrl: "modules/status/purchaserequest/templates/purchaserequestlist.html",
            controller: "PurchaseRequestListCtrl",
            controllerAs: "purchaseRequestListCtrl",
            process: "Status",
            workspace: "shop",
        },
        "/readonlypurchaserequestlist": {
            template: "<ixa-purchase-request-list-readonly></ixa-purchase-request-list-readonly>",
            templateUrl: "modules/status/purchaserequest/templates/purchaserequestlistreadonly.html",
            controller: "PurchaseRequestListReadOnlyCtrl",
            controllerAs: "purchaseRequestListReadOnlyCtrl",
            process: "PurchaseRequestListReadOnly",
            workspace: "shop",
        },
        "/approvalmodifiedpri/:id": {
            template: "<ixa-approval-modified-pri></ixa-approval-modified-pri>",
            templateUrl:
                "modules/status/purchaserequest/templates/approvalmodified.html",
            process: "PurchaseRequestView",
            controller: "ApprovalModifiedPriCtrl",
            controllerAs: "approvalModifiedCtrl",
            workspace: "shop",
        },
        "/simplepurchaserequestlist": {
            template: "<ixa-simple-purchase-request-list></ixa-simple-purchase-request-list>",
            templateUrl:
                "modules/status/purchaserequest/templates/simplepurchaserequestlist.html",
            process: "StatusSimple",
            controller: "SimplePurchaseRequestListCtrl",
            controllerAs: "simplePurchaseRequestListCtrl",
            workspace: "shop",
        },
        "/simplepurchaserequestadminlist": {
            template: "<ixa-simple-purchase-request-admin-list></ixa-simple-purchase-request-admin-list>",
            templateUrl:
                "modules/status/purchaserequest/templates/simplepurchaserequestadminlist.html",
            process: "StatusSimpleAdmin",
            controller: "SimplePurchaseRequestAdminListCtrl",
            controllerAs: "simplePurchaseRequestAdminListCtrl",
            workspace: "shop",
        },
        "/orderchangedetails/:originalPohId": {
            template: "<ixa-order-change-details></ixa-order-change-details>",
            process: "ViewBasket",
            workspace: "shop",
        },
    },
    ["ngRoute", "impactx.list", "impactx.statusicon"]
);
